import { ButtonHTMLAttributes, useRef, FunctionComponent } from 'react';
import { logAnalyticsEvent } from 'src/modules/analytics/analytics';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  'data-testid'?: string;
};

const TrackedButton: FunctionComponent<Props> = ({ onClick, ...props }) => {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <button
      ref={ref}
      onClick={event => {
        if (onClick) {
          onClick(event);
        }
        logAnalyticsEvent('button_click', {
          buttonName: props['data-testid'],
          buttonTextContent: ref.current?.textContent,
        });
      }}
      {...props}
    />
  );
};

export default TrackedButton;
